import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment/moment';
import { useEffect } from 'react';
import ExpenseDatePicker from './ExpenseDatePicker';
import { COLORS } from '../../../utils/Application_Constants';
import eventBus from './EventBus';

const VendorPaymentStartDate = (props) => {
    const { index, isViewOnly, expense, specialLabel = 'Start Date' } = props;
    const { control, errors } = useFormContext();

    useEffect(() => {
        if (expense.startDate) {
            eventBus.emit(`startDateChanged${index}`, {
                data: moment(expense.startDate).startOf('day').format('YYYY-MM-DD'),
            });
        }
    }, []);

    return (
        <Grid2 item>
            <Controller
                control={control}
                name={`expenseEntries[${index}].startDate`}
                defaultValue={expense.startDate || null}
                rules={{
                    validate: (value) => {
                        if (!value) {
                            return 'Start Date is required. Please enter a valid date.';
                        }
                        return true;
                    },
                }}
                disabled={isViewOnly}
                render={({ onChange, value }) => (
                    <ExpenseDatePicker
                        onChange={(e) => {
                            if (e?.isValid()) {
                                eventBus.emit(`startDateChanged${index}`, {
                                    data: e.startOf('day').format('YYYY-MM-DD'),
                                });
                                onChange(e);
                            }
                        }}
                        disabled={isViewOnly}
                        value={moment(value)}
                        id={`start-date-${index}`}
                        label={specialLabel}
                        required
                        parentTextFieldProps={{
                            error: Boolean(errors.expenseEntries?.[index]?.startDate),
                            helperText: errors.expenseEntries?.[index]?.startDate?.message,
                        }}
                        parentSx={{
                            '& .MuiPickersInputBase-root': {
                                borderColor: !errors.expenseEntries?.[index]?.startDate
                                    ? 'default'
                                    : `${COLORS.LT_PEPPER} !important`,
                            },
                        }}
                    />
                )}
            />
        </Grid2>
    );
};

export default VendorPaymentStartDate;
